import { jsxs as G, Fragment as $, jsx as r } from "react/jsx-runtime";
import { QUERIES as u } from "@fcamna/shared-component-foundations";
import o from "react";
import h from "styled-components";
import { u as P } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { AspectRatio as f } from "./aspectRatio.js";
import { c as i } from "./childrenCountCheck-785fa19a.mjs";
import "./index-65016bfa.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
const x = h.div`
  width: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.photoGalleryThumbnail.PhotoGalleryThumbnailContainer.width;
}};
  height: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.photoGalleryThumbnail.PhotoGalleryThumbnailContainer.height;
}};
  display: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.photoGalleryThumbnail.PhotoGalleryThumbnailContainer.display;
}};
  flex-direction: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.photoGalleryThumbnail.PhotoGalleryThumbnailContainer.flexDirection;
}};
  gap: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.photoGalleryThumbnail.PhotoGalleryThumbnailContainer.gap;
}};
  flex-wrap: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.photoGalleryThumbnail.PhotoGalleryThumbnailContainer.flexWrap;
}};
  @media ${u.tabletAndUp} {
    flex-wrap: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.photoGalleryThumbnail.PhotoGalleryThumbnailContainer.tabletAndUp.flexWrap;
}};
  }
`, g = (e, t) => {
  const a = {
    "33-3": "calc(50% - 12px)",
    "33-2": "100%",
    "25-4": "calc(50% - 12px)",
    "25-3": "100%",
    "50-3": "100%",
    "50-2": "calc(50% - 12px)",
    "66-2": "100%",
    "66-1": "100%",
    100: "100%"
  };
  return a[`${e}-${t}`] || a[`${e}`] || "auto";
}, C = (e, t) => {
  const a = {
    "25-4": "25%",
    "25-3": "calc(25% - 12px)",
    "50-3": "50%",
    "50-2": "50%",
    "33-2": "calc(33.5% - 15px)",
    "33-3": "33.33%",
    "66-2": "calc(66.5%)",
    100: "100%"
  };
  return a[`${e}-${t}`] || a[`${e}`];
}, c = h.div`
  width: ${(e) => C((e == null ? void 0 : e.$size) || 100, e.$count || 1)};
  display: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.photoGalleryThumbnail.PhotoGalleryThumbnailWrapper.display;
}};
  flex-direction: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.photoGalleryThumbnail.PhotoGalleryThumbnailWrapper.flexDirection;
}};
  gap: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.photoGalleryThumbnail.PhotoGalleryThumbnailWrapper.gap;
}};

  img {
    transition: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.photoGalleryThumbnail.PhotoGalleryThumbnailAspectRatio.img.transition;
}};

    &:hover {
      transform: ${(e) => {
  var t;
  return e.$disableHoverZoom ? "none" : (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.photoGalleryThumbnail.PhotoGalleryThumbnailAspectRatio.img.hover.transform;
}};
    }
  }

  @media ${u.mobile} {
    flex-direction: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.photoGalleryThumbnail.PhotoGalleryThumbnailWrapper.mobile.flexDirection;
}};
    width: ${(e) => g(e.$size || 100, e.$count || 1)};

    ${(e) => e.$size === 33 && e.$count === 3 && `
      &:nth-child(3) {
        width: 100%;
      }
    `}

    ${(e) => e.$size === 66 && e.$count === 2 && `
      &:nth-child(2) {
        width: 100%;
      }
    `}
  }
`, v = h(f)`
  border-radius: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.photoGalleryThumbnail.PhotoGalleryThumbnailAspectRatio.borderRadius;
}};
  overflow: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.photoGalleryThumbnail.PhotoGalleryThumbnailAspectRatio.overflow;
}};
  gap: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.photoGalleryThumbnail.PhotoGalleryThumbnailAspectRatio.gap;
}};
  height: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.photoGalleryThumbnail.PhotoGalleryThumbnailAspectRatio.height;
}};
`, W = ({ children: e }) => /* @__PURE__ */ r(
  v,
  {
    ratio: "16/9",
    objectFit: "fill",
    children: e
  }
), A = {
  25: 2,
  33: 2,
  50: 1,
  66: 1,
  100: 1
}, b = ({ children: e, size: t, disableHoverZoom: a = !1 }) => {
  const y = P({ label: "Photo Gallery Thumbnail" }), d = t.reduce((l, n) => l + n, 0) <= 100, T = o.Children.map(e, (l, n) => {
    var m;
    return i({
      children: (m = l == null ? void 0 : l.props) == null ? void 0 : m.children,
      maxChildren: A[t[n]],
      componentName: "PhotoGalleryThumbnail.Wrapper",
      additionalInfo: "Please remove the extra PhotoGalleryThumbnail.Item children from inside the PhotoGalleryThumbnail.Wrapper"
    }), o.isValidElement(l) && l.type === c ? o.cloneElement(l, { $size: t[n], $disableHoverZoom: a, $count: t.length }) : "invalid element";
  });
  return i({
    children: e,
    componentName: "PhotoGalleryThumbnail",
    maxChildren: t.length
  }), /* @__PURE__ */ G($, { children: [
    i({
      children: e,
      componentName: "PhotoGalleryThumbnail",
      maxChildren: t.length,
      additionalInfo: "Please remove the extra PhotoGalleryThumbnail.Wrapper children from inside the PhotoGalleryThumbnail"
    }),
    /* @__PURE__ */ r(x, { ...y, children: d ? T : "Unsupported ratio, please use a supported ratio whose sum does not exceed 100. Examples: [25,50,25] or [33,66]" })
  ] });
};
b.Wrapper = c;
b.Item = W;
export {
  b as PhotoGalleryThumbnail
};
